import * as types from "../actionTypes/catalogManagementUnitsAT";
import * as omnimap from "../../api/omnimap/omnimapApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function load(data) {
  return { type: types.LOAD_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function create(data) {
  return { type: types.CREATE_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function update(data) {
  return { type: types.UPDATE_CATALOG_MANAGEMENT_UNITS_SUCCESS, data };
}

export function deleteA(data) {
  return { type: types.DELETE_CATALOG_MANAGEMENT_UNITS_OPTIMISTIC, data };
}

// export function loadModel() {
//   return function(dispatch) {
//     dispatch(beginApiCall());
//     return omnimap
//       .getCourses()
//       .then(courses => {
//         dispatch(loadCourseSuccess(courses));
//       })
//       .catch(error => {
//         dispatch(apiCallError(error));
//         throw error;
//       });
//   };
// }

export function SaveOrUpdate(model, method, id, token) {
  //eslint-disable-next-line no-unused-vars
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return omnimap
      .SaveOrEdit(model, method, id, token)
      .then((result) => {
        dispatch(update(result));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
// export function saveModel(course) {
//   //eslint-disable-next-line no-unused-vars
//   return function(dispatch, getState) {
//     dispatch(beginApiCall());
//     return courseApi
//       .saveCourse(course)
//       .then(savedCourse => {
//         course.id
//           ? dispatch(updateCourseSuccess(savedCourse))
//           : dispatch(createCourseSuccess(savedCourse));
//       })
//       .catch(error => {
//         dispatch(apiCallError(error));
//         throw error;
//       });
//   };
// }

// export function deleteModel(course) {
//   return function(dispatch) {
//     // Doing optimistic delete, so not dispatching begin/end api call
//     // actions, or apiCallError action since we're not showing the loading status for this.
//     dispatch(deleteCourseOptimistic(course));
//     return courseApi.deleteCourse(course.id);
//   };
// }
